import React, {useState} from 'react'
import {BackButton, VisDiv, Photos, Comments, Divider, TextField, UserIcon, FieldDropdown} from '../components';
import {useStateContext} from '../context/StateContext';
import { ViewEditField } from '../components/frontend_components/ViewAndEdit';
import { expandReference, keyId, removeEmptyProperties, sortByLabel } from '../lib/utils';
import useNetworkStatus from '../hooks/useNetworkStatus';
import { technician, clientUser, facilityClient, isGodMode } from '../lib/userPermissions';
import { HistoryLogs } from './device';
import { userLogCheck, timePassedTranslated, objectIsObject } from '../lib/utils';
import { deviceLogsExpanded } from '../lib/utils';
import { addLogToDoc } from '../lib/utils';
import { IoMdCheckmark } from "react-icons/io";
import { all } from 'axios';
import { matchNonConformities } from '../lib/tagLogic';
import { referenceDoc } from '../components/gestioneDatabase/Docs';



/**
 * deviceNonConformity component to show and edit non conformity information
 * #deviceNonConformities
 * @param {pin} if true, then the component will render a pin
 * @param {device} the device to which the non conformity belongs
 * @param {data} the data of the device
 * @param {deviceNonConformity} the non conformity to show
 * @param {saveFn} the function to call when the non conformity is saved
 * @param {deleteFn} the function to call when the non conformity is deleted
 */
const NonConformity = ({pin, device, data={}, deviceNonConformity, saveFn, deleteFn=()=>{}}) => {

    const {LDB, sUser, setDeviceIndexPage, currentTemplate, currentNonConformity, setCurrentNonConformity} = useStateContext();
    const currentDeviceNonConformity = deviceNonConformity ? deviceNonConformity : currentNonConformity
    const client = data?.client ? data?.client: useStateContext()?.client
    const site = data?.site ? data?.site: useStateContext()?.site
    const customerUsers = data?.customerUsers ? data?.customerUsers: useStateContext()?.customerUsers
    const nonConformities = data?.nonConformities ? data?.nonConformities: useStateContext()?.nonConformities
    
    const templateNonConformities = matchNonConformities(device, nonConformities, currentTemplate)?.sort(sortByLabel)


    const nonConformityTemplate = nonConformities?.find?.((x)=>x?._id==currentDeviceNonConformity?.nonConformity?._ref)
    const networkStatus = useNetworkStatus()
    const P = "nonConformity"

    const deviceLogs = currentDeviceNonConformity?.userLog ? currentDeviceNonConformity?.userLog : []
    const expandedNonConformity = {...objectIsObject(currentDeviceNonConformity), userLog: deviceLogsExpanded(deviceLogs, customerUsers)}
    const postedBy = customerUsers?.find?.((x)=> x._id == currentDeviceNonConformity?.postedBy?.[0]?._ref)

    const [nonConfInfo, setNonConfInfo] = useState({})
    const [doneBy, setDoneBy] = useState(userLogCheck(expandedNonConformity))
    const nNonConfInfoProperties = Object.keys(removeEmptyProperties(nonConfInfo))?.length
    const [nonConformityTemplateOption, setNonConformityTemplateOption] = useState({...nonConformityTemplate, value: nonConformityTemplate?.label})
    const allTemplateNonConformities = (x) =>{ 
        const nonConformities = !x?.nonConformities ? [] : x?.nonConformities
        const array = [...!Array.isArray(nonConformities) ? [] : nonConformities, x?.maxNonConformity, x?.minNonConformity, x?.zeroNonConformity ].filter?.(x=>x)
        return array
    }
    
    const fieldTemplate = currentTemplate?.fields?.find?.(x=>allTemplateNonConformities(x)?.find?.(y=>y?._id == currentDeviceNonConformity?.nonConformity?._ref))
    const deviceField = device?.fields?.find?.(x=>x?.templateField?._ref==fieldTemplate?._id)

    const maintenanceFieldTemplate = currentTemplate?.dates?.find?.(x=>allTemplateNonConformities(x)?.find?.(y=>y?._id == currentDeviceNonConformity?.nonConformity?._ref))
    const maintenanceDeviceField = device?.dates?.find?.(x=>x?.templateField?._ref==maintenanceFieldTemplate?._id)
    
    const [deviceFieldValue, setDeviceFieldValue] = useState([deviceField ? deviceField : maintenanceDeviceField])
     
    const now = Date.now()
    const doc = (newStatus) => { 
        
        if(newStatus == "ARCHIVIATO") return {...objectIsObject(currentDeviceNonConformity), ...objectIsObject(nonConfInfo), status: newStatus, archivedOn: now, archivedBy: [{ _type: 'postedBy', _ref: sUser._id,  _key: keyId()}] }
        if(newStatus == "COMPLETATO") return {...objectIsObject(currentDeviceNonConformity), ...objectIsObject(nonConfInfo), status: newStatus, completedOn: now, completedBy: [{ _type: 'postedBy', _ref: sUser._id,  _key: keyId()}]}
        if(newStatus == "ORDINATO") return {...objectIsObject(currentDeviceNonConformity), ...objectIsObject(nonConfInfo), status: newStatus, assignedOn: now, assignedBy: [{ _type: 'postedBy', _ref: sUser._id,  _key: keyId()}]}
        if(newStatus == "DA FARE") return {...objectIsObject(currentDeviceNonConformity), ...objectIsObject(nonConfInfo), status: newStatus, archivedOn: null, archivedBy: null }

        return {...objectIsObject(currentDeviceNonConformity), ...objectIsObject(nonConfInfo)}
    }
    const updateCommentDoc = (data)=> {
        const comments = currentDeviceNonConformity?.comments ? currentDeviceNonConformity?.comments : []
        const newDoc = {...objectIsObject(currentDeviceNonConformity), ...objectIsObject(nonConfInfo), comments:[...!Array.isArray(comments) ? [] : comments?.filter?.((x=>x?._key !== data?._key)), data] }
        return (newDoc)
    }
    const updatePictureDoc = (data)=> {
        const pictures = currentDeviceNonConformity?.images ? currentDeviceNonConformity?.images : []
        const newDoc = {...objectIsObject(currentDeviceNonConformity), ...objectIsObject(nonConfInfo), images:[...!Array.isArray(pictures) ? [] : pictures.filter?.((x=>x?._key !== data?._key)), data] }
        return (newDoc)
    }
    const updatePictureSanityDoc = (data)=> {
        const pictures = currentDeviceNonConformity?.image ? currentDeviceNonConformity?.image : []
        const newDoc = {...objectIsObject(currentDeviceNonConformity), ...objectIsObject(nonConfInfo), image:[...!Array.isArray(pictures) ? [] : pictures.filter?.((x=>x?._key !== data?._key)), data] }
        return (newDoc)
    }
    const testFunction = () =>{
        const fields = currentTemplate?.fields
        const fieldTemplate = !Array.isArray(fields) ? undefined : fields?.find?.(x=>!Array.isArray(allTemplateNonConformities(x)) ? undefined : allTemplateNonConformities(x)?.find?.(y=>y?._id == currentDeviceNonConformity?.nonConformity?._ref))
        //console.log("current template", currentTemplate, "current non conformity", currentDeviceNonConformity, "fieldTemplate", fieldTemplate, "all non conformities", fields)
        console.log("kjasnjkasndjksa non conf", {currentTemplate, nonConformityTemplate, nonConformityTemplateOption, currentDeviceNonConformity, fieldTemplate, fields })
        navigator.clipboard.writeText(nonConformityTemplate?._id)
        
    }
 //=========================================== SAVE FUNCTIONS ===============================================

    const saveNonConformity = () => {
        const docWithLog = addLogToDoc(sUser,doc(),"Non Conformity Saved")
        saveFn(docWithLog, device)
        setCurrentNonConformity(docWithLog)
        setNonConfInfo({})
    }

    const editComment = (data) => {
        const newDoc = updateCommentDoc(data)
        const docWithLog = addLogToDoc(sUser,newDoc,"Comment Added/Updated")
        setCurrentNonConformity(docWithLog)
        saveFn(docWithLog, device)
    }
    const insertPicture = (data) => {
        const newDoc = updatePictureDoc(data)
        const docWithLog = addLogToDoc(sUser,newDoc,"Picture Added/Updated")
        setCurrentNonConformity(docWithLog)
        saveFn(docWithLog, device)
    }
    const insertPictureSanity = (data) => {
        const newDoc = updatePictureSanityDoc(data)
        const docWithLog = addLogToDoc(sUser,newDoc,"Picture Added/Updated")
        setCurrentNonConformity(docWithLog)
        saveFn(docWithLog, device)
    }
    const complete = () => {
        const docWithLog = addLogToDoc(sUser, doc("COMPLETATO"),"Non Conformity Completed")
        saveFn(docWithLog, device, deviceFieldValue)
        setDeviceIndexPage("DEVICE")
    }
    const restore = () => {
        const docWithLog = addLogToDoc(sUser,doc("DA FARE"),"Non Conformity Restored")
        saveFn(docWithLog, device)
        setCurrentNonConformity(doc("DA FARE"))
        //setDeviceIndexPage("DEVICE")
    }
    const assign = () => {
        const docWithLog = addLogToDoc(sUser,doc("ORDINATO"),"Non Conformity Assigned")
        saveFn(docWithLog, device)
        setCurrentNonConformity(docWithLog)
        //setDeviceIndexPage("DEVICE")
    }
    const cancel = () => {
        setDeviceIndexPage("DEVICE")
    }
    const archive = () => {
        const docWithLog = addLogToDoc(sUser,doc("ARCHIVIATO"),"Non Conformity Archived")
        saveFn(docWithLog, device)
        setDeviceIndexPage("DEVICE")
    }
    const erase = () => {
        const docWithLog = addLogToDoc(sUser,doc("ARCHIVIATO"),"Non Conformity Deleted")
        deleteFn(docWithLog)
        setDeviceIndexPage("DEVICE")
    }

    const statusTranslate = (status) => {
        //LDB(P, "noAssignedNonConformities")
        if(status == "ARCHIVIATO") return LDB("misc", "archived")
        if(status == "COMPLETATO") return LDB("misc", "completed")
        if(status == "ORDINATO") return LDB("misc", "ordered")
        if(status == "DA FARE") return LDB("misc", "toDo")
    }
    const statusColor = () => {
        const status = currentDeviceNonConformity?.status
        if(status == "ARCHIVIATO") return "grey"
        if(status == "COMPLETATO") return "green"
        if(status == "ORDINATO") return "#FFBF00"
        if(status == "DA FARE") return "red"
    }
    const currentTemplateDevice = expandReference(device?.templateDevice, currentTemplate?.devices)

    //=========================================== RETURNS ===============================================
    if(pin){
        const testPin = () => {
            console.log("hudnkbskjdcgb", {currentDeviceNonConformity, })
        }
        const nNonConformities = !pin && currentDeviceNonConformity?.nNonConformities > 1 ? ` X${currentDeviceNonConformity?.nNonConformities}` : ""
        const iconColour = currentDeviceNonConformity?.status == "COMPLETATO" ? {backgroundColor:"green", color:"white"} :  {backgroundColor:"red", color:"white"}
        return (
        <>    
        <div style={{display:"flex", alignItems:"center", padding:"10px"}} >
             <div onClick={()=>{ currentDeviceNonConformity?.status == "COMPLETATO" ? restore() :  complete()}} style={{...iconColour, minWidth:"28px", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", marginRight:"10px", width:"30px", height:"30px"}}>
                <IoMdCheckmark size={15}/>
            </div>

            <p onClick={testPin}>{nonConformityTemplate?.label }{nNonConformities}</p>

        </div>
        <div></div>
        </>
    )}
    return (
        <div className={networkStatus ? "new-device-container" : "new-device-container stop-scroll-refresh" }>
            
            <div className='title-with-side-icons'>
                <BackButton onClick={()=>setDeviceIndexPage("DEVICE")}/>
                <div style={{color:"red", textAlign:"center"}}>
                    <h2>{nonConformityTemplate?.label}</h2>
                </div>
                <div></div>
            </div>
            <div style={{display:"flex", alignItems:"center", marginTop:"10px", flexDirection:"column"}}>
                <p>INDIVIDUATA DA:</p>
                <UserIcon
                    otherUser={postedBy && postedBy}
                    date={currentDeviceNonConformity?.createdOn}
                    name
                />
                <p style={{marginTop:"10px"}}>{device?.label}</p>
                <p>{site?.label}</p>
                <h3 style={{marginTop:"10px"}}>{LDB(P, "statusTitle")}:</h3>
                <h3 style={{marginTop:"10px", color: statusColor()}}>{statusTranslate(currentDeviceNonConformity?.status)}</h3>
            
            </div>
            <VisDiv rules={[sUser?.userType == "God Mode"]}>
                <button onClick={testFunction}>copy Id</button>
            </VisDiv>
            <VisDiv rules={[facilityClient(client, sUser), clientUser(sUser)]}>
                <h4>CAMBIA NON CONFORMITA':</h4>
            </VisDiv>
            <FieldDropdown
                initialValue = {nonConformityTemplateOption}
                onChange = {(value) => {
                    setNonConfInfo({...objectIsObject(nonConfInfo), nonConformity: referenceDoc(value?._id)})
                    setNonConformityTemplateOption(value)
                }}
                isSearchable = {true}
                options={templateNonConformities}
            />
            <VisDiv rules={[facilityClient(client, sUser), clientUser(sUser)]}>
                <h4>{LDB(P, "nNonConformities")}:</h4>
            </VisDiv>
            
            <VisDiv rules={[facilityClient(client, sUser), clientUser(sUser)]} style={{width:"90px"}}>
                <TextField
                    defaultValue={currentDeviceNonConformity?.nNonConformities}
                    onChange={(e) => {
                        if(e.target.value == "") {
                            setNonConfInfo({...objectIsObject(nonConfInfo), nNonConformities: null})
                        } else {
                            setNonConfInfo({...objectIsObject(nonConfInfo), nNonConformities: e.target.value})
                        } 
                    }}
                />
            </VisDiv>
            <VisDiv style={{display: "flex", alignItems:"center", justifyContent:"center", marginBottom:"15px"}} rules={[nNonConfInfoProperties > 0]} className='bottom-buttons'>
                <button type="button" style={{backgroundColor: "green"}} className="btn" onClick={()=>saveNonConformity()} >{LDB("misc", "save")}</button>
            </VisDiv>
            <Divider/>
            <VisDiv>
                <ViewEditField
                    //errors={allErrors}
                    device={device}
                    item={fieldTemplate ? fieldTemplate : maintenanceFieldTemplate} 
                    state={deviceFieldValue} 
                    setState={setDeviceFieldValue} 
                    collection={fieldTemplate ? device?.fields : device?.dates}
                    deviceEdit={true}
                    currentTemplateDevice={currentTemplateDevice} 
                />
            </VisDiv>
{/*             <Photos
                destination={currentDeviceNonConformity} 
                saveFn = {insertPicture}
                saveSanityFn={insertPictureSanity}
            /> */}
            <VisDiv rules={[clientUser(sUser)]}>
                <Comments
                    destination={currentDeviceNonConformity}
                    editFn = {editComment}
                />
            </VisDiv>
            

            <VisDiv rules={[facilityClient(client, sUser), clientUser(sUser) ]} className='bottom-buttons' style={{marginBottom:"18px"}} >
                <VisDiv className='bottom-button' rules={[
                    false,
                    technician(sUser), 
                    currentDeviceNonConformity?.status !== "ORDINATO", 
                    currentDeviceNonConformity?.status !== "COMPLETATO", 
                    currentDeviceNonConformity?.status !== "ARCHIVIATO"]}>
                        <button type="button" style={{backgroundColor: "#FFBF00"}} className="btn" onClick={()=>assign()}>{LDB("misc", "assign")}</button>
                </VisDiv>
                <VisDiv rules={[false, currentDeviceNonConformity?.status == "ORDINATO"]}className='bottom-button'>
                        <button type="button" style={{backgroundColor: "#FFBF00"}} className="btn" onClick={()=>restore()}>{LDB("misc", "removeOrder")}</button>
                </VisDiv>
                <VisDiv rules={[currentDeviceNonConformity?.status !== "COMPLETATO", currentDeviceNonConformity?.status !== "ARCHIVIATO"]}className='bottom-button'>
                        <button type="button" style={{backgroundColor: "green"}} className="btn" onClick={()=>complete()}>{LDB("misc", "complete")}</button>
                </VisDiv>
                <VisDiv rules={[currentDeviceNonConformity?.status == "COMPLETATO" || currentDeviceNonConformity?.status == "ARCHIVIATO"]}className='bottom-button'>
                        <button type="button" style={{backgroundColor: "green"}} className="btn" onClick={()=>restore()}>{LDB("misc", "restore")}</button>
                </VisDiv>
                <VisDiv rules={[currentDeviceNonConformity?.status !== "COMPLETATO", currentDeviceNonConformity?.status !== "ARCHIVIATO"]}className='bottom-button'>
                        <button type="button" style={{backgroundColor: "red"}} className="btn" onClick={()=>archive()}>{LDB("misc", "archive")}</button>
                </VisDiv>
                <VisDiv rules={[isGodMode(sUser)]}className='bottom-button'>
                    <button type="button" style={{backgroundColor: "red"}} className="btn" onClick={()=>erase()}>{"ELIMINA"}</button>
                </VisDiv>
                <VisDiv className='bottom-button'>
                        <button type="button" style={{backgroundColor:"grey"}} className="btn" onClick={cancel} >{LDB("misc", "cancel")}</button>
                </VisDiv>
            </VisDiv>

            <VisDiv rules={[deviceLogs?.length>0]} style={{display:"flex", justifyContent:"left", flexDirection:"column" }}>  
                <VisDiv style={{display:"flex", justifyContent:"center"}}>     
                    <h2>{LDB("device", "logs")}</h2>
                </VisDiv>   
                    <div>
                        <HistoryLogs userLogList={ expandedNonConformity?.userLog}/>
                    </div>                     
            </VisDiv>
            
        </div>
    )
}

export default NonConformity
